import dayjs from 'dayjs'
import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, IconButton } from '@material-ui/core'
import { useCheckPolicy } from '../../../../hooks'
import { ACCOUNTS } from '../../../../policies/admin'
import Text from '../../../atoms/Text'
import Icon from '../../../atoms/Icon'
import { ICON_NAMES } from '../../../../constants'
import { useModifyAccountPerformanceStartDateMutation } from '../../../../api/accounts'
import QuickEditDateModal from './QuickEditDateModal'

const PerformanceDateInput = ({
  account,
  disableEdit
}) => {
  const { performanceStartDate, closeDate, startDate, accountId } = account ?? {}

  const [isEditing, setIsEditing] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const userCanEdit = useCheckPolicy(ACCOUNTS.editPerformanceStartDate)
  const formattedValue = useMemo(() => {
    if (!performanceStartDate) return '--'
    return dayjs.utc(performanceStartDate).format('MM/DD/YYYY')
  }, [performanceStartDate])
  const dateRange = useMemo(() => ({
    ...(closeDate && { maxDate: dayjs.utc(closeDate).add(-1, 'day').format('YYYY-MM-DD') }),
    ...(startDate && { minDate: dayjs.utc(startDate).add(1, 'day').format('YYYY-MM-DD') })
  }), [closeDate, startDate])

  const { mutateAsync: setPerformanceStartDate } = useModifyAccountPerformanceStartDateMutation()
  const onSubmit = useCallback(async (values) => {
    setIsSubmitting(true)
    await setPerformanceStartDate({
      accountId,
      performanceStartDate: values.performanceStartDate || null
    }).catch(() => {
      setIsSubmitting(false)
    })
    setIsEditing(false)
    setIsSubmitting(false)
  }, [accountId, setPerformanceStartDate])

  return (
    <>
      <Box display='flex' gridGap='.5rem'>
        <Text text='Performance Start Date' customFontSize='18px' customFontWeight='600' />
        {userCanEdit && (
          <Box height='2rem' mt='-.55rem'>
            <IconButton
              onClick={() => setIsEditing(true)}
              disabled={disableEdit}
              editMode={isEditing}
            >
              <Icon name={ICON_NAMES.edit} customSize='18px' />
            </IconButton>
          </Box>
        )}
      </Box>

      <Text text={formattedValue} customFontSize='18px' />

      {isEditing && (
        <QuickEditDateModal
          title='Edit Performance Start Date'
          subtitle='Edit or clear the performance start date'
          onSubmit={onSubmit}
          onClose={() => setIsEditing(false)}
          value={performanceStartDate}
          allowClear
          requireBusinessDay
          keyName='performanceStartDate'
          displayFormat='MM/DD/YYYY'
          isSubmitting={isSubmitting}
          dateRange={dateRange}
        />
      )}
    </>
  )
}

PerformanceDateInput.propTypes = {
  account: PropTypes.object,
  disableEdit: PropTypes.bool
}

export default PerformanceDateInput
